var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.75V1.00247C5 0.448822 5.44386 0 6 0C6.55228 0 7 0.455761 7 1.00247V4.75H10.9975C11.5512 4.75 12 5.19387 12 5.75C12 6.30229 11.5442 6.75 10.9975 6.75H7V10.9975C7 11.5512 6.55613 12 6 12C5.44771 12 5 11.5442 5 10.9975V6.75H1.00247C0.448823 6.75 0 6.30614 0 5.75C0 5.19772 0.455761 4.75 1.00247 4.75H5Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.165abeea5e980d665bf6d0df62c216ad.svg";
export { ForwardRef as ReactComponent };